import React, { useState } from "react";
import {
  TableCell,
  TableRow,
  TextField,
  Stack,
  IconButton,
  Tooltip,
} from "@mui/material";
import { TargetType } from "../../../../domain/models/target/target-type";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import moment from "moment";
import { TargetStore } from "../../../../store/main/TargetStore";

type Props = {
  data: TargetType;
  isEditing: boolean;
  setEditingRow: (id: string | null) => void;
};

const TargetTableDetail: React.FC<Props> = ({
  data,
  isEditing,
  setEditingRow,
}) => {
  const { filterStore } = CustomerDatabaseStore();
  const { updateTarget } = TargetStore();
  const [targetValue, setTargetValue] = useState(data.target);

  const handleEditClick = () => {
    setEditingRow(`${data.headquarter_id}-${data.product_id}`);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTargetValue(event.target.value);
  };

  const handleSaveClick = () => {
    setEditingRow(null);
    const month = moment(filterStore.date).format("MM");
    const year = moment(filterStore.date).format("yy");
    const payload = {
      month_year: parseInt(`${year}${month}`),
      headquarter_id: data.headquarter_id,
      product_id: data.product_id,
      target: targetValue,
    };
    updateTarget(payload);
  };

  const handleCancelClick = () => {
    setTargetValue(data.target);
    setEditingRow(null);
  };

  return (
    <TableRow>
      <TableCell>{data.zone}</TableCell>
      <TableCell>{data.region}</TableCell>
      <TableCell>{data.area}</TableCell>
      <TableCell>{data.headquarter}</TableCell>
      <TableCell>{data.headquarter_id}</TableCell>
      <TableCell>{data.product_code}</TableCell>
      <TableCell>{data.product}</TableCell>
      <TableCell>{data.product_id}</TableCell>
      <TableCell style={{ width: "200px" }}>
        {isEditing ? (
          <Stack direction={"row"}>
            <TextField
              value={targetValue}
              onChange={handleInputChange}
              size="small"
            />
            <Tooltip title="Update Target">
              <IconButton
                onClick={handleSaveClick}
                size="small"
                color="primary"
              >
                <CheckIcon color="success" fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel">
              <IconButton
                onClick={handleCancelClick}
                size="small"
                color="primary"
              >
                <CloseIcon color="error" fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : (
          <span onClick={handleEditClick}>{targetValue}</span>
        )}
      </TableCell>
    </TableRow>
  );
};

export default TargetTableDetail;
